import { getModuleAssets } from "seneca-common/features/calculation/module/initialization/assets";
import { generateContent } from "seneca-common/features/calculation/module/initialization/generateContent";
import { initialiseState } from "seneca-common/features/calculation/module/initialization/initialiseState";
import { ModuleRegistry } from "seneca-common/features/module/registry";

export const MODULE_TYPE = "simple-calculation";

export const register = (moduleRegistry: ModuleRegistry) =>
  moduleRegistry
    .buildModule(MODULE_TYPE)
    .with.logic()
    .markAnswer((content, score) => score)
    .getModuleAssets(getModuleAssets)
    .generateContent(source =>
      generateContent({ source, generateScaffolding: true })
    )
    .generateInitialModuleState(initialiseState)
    .back.staticInformation()
    .testOnly()
    .displayName("Simple Calculation")
    .root.register();
